import faker from 'faker';

import { IContractItem, IContractItemData } from '../contract.types';
import { ContractItem } from '../contract';
import { createRange } from '@/utils/helpers';

export function createRandomContractItem(): IContractItemData {
  return {
    id: faker.datatype.number(),
    item: faker.commerce.productName(),
    quantity: faker.datatype.number(),
    activation_date: faker.date.past().toISOString(),
    net_price: parseFloat(faker.commerce.price())
  };
}

export const mockContractItemsData: IContractItemData[] = createRange(
  6
).map(() => createRandomContractItem());

export const mockContractItems = (
  data: IContractItemData[] = mockContractItemsData
): IContractItem[] => data.map(item => new ContractItem(item));
